"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M10.02 6 8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6z"
}), 'NavigateNextOutlined');